<div #passwordField>
  <mat-form-field>
    <lui-form-field-indicator></lui-form-field-indicator>

    <mat-label>{{ props.label }}</mat-label>
    <input
      matInput
      [formControl]="formControl"
      [formlyAttributes]="field"
      type="password"
      #passwordInput="matInput"
    />
    <input type="hidden" />

    <la-password-requirements
      *ngIf="props.withHelper"
      [anchor]="passwordField"
      [control]="formControl"
      [open]="passwordInput.focused"
    ></la-password-requirements>
    <mat-error>
      <formly-validation-message [field]="field"></formly-validation-message
    ></mat-error>
  </mat-form-field>
</div>
